//export const ServerURL = "http://uatpegaalpapp02:7010"; //Testing
// export const ServerURL = "https://gstc2-fe-uat.zatca.gov.sa"; //UAT
export const ServerURL = "https://gstc-fe.zatca.gov.sa"; //Production
// export const ServerURL = "https://gstc2-fe-vs.gstc.gov.sa"; //Pre-Production
// export const ServerURL = "http://10.55.93.51:7010";
// export const ServerURL = "http://localhost:7010";
export const BaseName = "/Login/External";
//ChannelID & Server URL UAT
export const ChannelIdUAT = "MASHUP899d3119b4844be4a8d76515bf6de1cc";
export const PegaServerUAT = "https://pega-alpha-uat-fe.zatca.gov.sa";
//ChannelID & Server URL Pre-Production
export const ChannelIdPre = "MASHUP73a2fe68cf0c4898b1bd2eb0519377c8";
export const PegaServerPre = "https://gstc2-proxy-pre.gstc.gov.sa";
//ChannelID & Server URL Production
export const ChannelIdProd = "MASHUP899d3119b4844be4a8d76515bf6de1cc";
export const PegaServerProd = "https://gstc-proxy.zatca.gov.sa";
